module.exports = __webpack_public_path__ + "img/blog-15-1.f383a2e3.webp";